import { makeStyles } from "@mui/styles";

export const navigationStyles = makeStyles(() => ({
  navigationRoot: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));
